'use strict';

module.exports = function mapInto(ClassName) {
  return this.map(function (value, key) {
    return new ClassName(value, key);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/mapInto.js
// module id = 1243
// module chunks = 2